// @core/api/endpoints/analytics/query_time_series.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  QueryTimeSeriesRequest,
  QueryTimeSeriesResponse,
} from '../../../types/analytics';

const BASE_PATH = '/analytics';

/**
 * Query time series data
 * Returns time-bucketed data points for the specified metrics. Used for line charts, area charts, and trend analysis.
 */
export async function QueryTimeSeries(
  data: QueryTimeSeriesRequest,
  options?: RequestOptions
): Promise<QueryTimeSeriesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/analytics/query/timeseries`;
  const requestOptions = options;
  return client.post<QueryTimeSeriesResponse>(requestPath, data, requestOptions);
}
